import {
  ChangeDetectionStrategy,
  Component,
  OnInit
} from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-main-header",
  templateUrl: "./header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  constructor(
    protected router: Router,
  ) {}
  ngAfterViewInit() {
  }

  ngOnInit() {
  }
}
